import React, { useEffect, useState } from 'react'
import { NavLink, useNavigate, useLocation } from 'react-router-dom'


const Navigation = () => {
  const [showNav, setShowNav] = useState(true)
  const [lastScrollY, setLastScrollY] = useState(0)
  const [sidebarOpen, setSidebarOpen] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY

      if (Math.abs(currentScrollY - lastScrollY) < 10) return

      if (currentScrollY > lastScrollY) {
        setShowNav(false)
      } else {
        setShowNav(true)
      }

      setLastScrollY(currentScrollY)
    }

    window.addEventListener('scroll', handleScroll)

    return () => window.removeEventListener('scroll', handleScroll)
  }, [lastScrollY])

  const navigate = useNavigate();
  const location = useLocation();

  const handleScrollTo = (e, sectionId) => {
    e.preventDefault();

    if (location.pathname !== '/') {
      // Go to `/` and pass the section ID in state
      navigate('/', { state: { scrollToId: sectionId } });
    } else {
      // Already on `/`, just scroll
      const target = document.querySelector(sectionId);
      if (target) {
        target.scrollIntoView({ behavior: 'smooth' });
      }
    }

    closeSidebar();
  };

  // useEffect(() => {
  //   if (sidebarOpen) {
  //     document.body.style.overflow = 'hidden';
  //   } else {
  //     document.body.style.overflow = 'auto';
  //   }
  // }, [sidebarOpen]);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen)
  }

  const closeSidebar = () => {
    setSidebarOpen(false)
  }

  return (
    <section id="NavigationBar" className={showNav ? 'show' : 'hide'}>
      <div className="NavigationContainer">
        <div className="LeftNavigation">Ignatius Michael Dinata</div>

        <div className={`HamburgerIcon ${sidebarOpen ? 'open' : ''}`} onClick={toggleSidebar}>
          <span></span>
          <span></span>
          <span></span>
        </div>

        {sidebarOpen && <div className="Overlay" onClick={closeSidebar}></div>}

        <div className={`RightNavigation ${sidebarOpen ? 'open' : ''}`}>
          <NavLink className="NavigationList" exact="true" to="/" onClick={closeSidebar}>
            Home
          </NavLink>
          
          {/* <NavLink className="NavigationList" exact="true" to="/about" onClick={closeSidebar}>
            About
          </NavLink> */}
          {/* <a href="#AboutPage" className='NavigationList' onClick={closeSidebar} >About</a> */}
          <a
            href="/#AboutPage"
            className="NavigationList"
            onClick={(e) => handleScrollTo(e, '#AboutPage')}
          >
            About
          </a>
          
          <NavLink className="NavigationList" exact="true" to="/portfolio" onClick={closeSidebar}>
            Portfolio
          </NavLink>

          {/* <NavLink className="NavigationList" exact="true" to="/oriflame" onClick={closeSidebar}>
            Oriflame
          </NavLink> */}

          {/* <NavLink className="NavigationList" exact="true" to="/contact" onClick={closeSidebar}>
            Contact
          </NavLink> */}
        </div>
      </div>
    </section>
  )
}

export default Navigation
